import { Component, Inject, LOCALE_ID, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';
import { ProductoService } from '@abm/producto/producto.service';
import { UsuarioService } from '@account/usuario.service';
import { Aeroespecialidad } from '@shared/models/cierreTurno/aeroespecialidad';
import { CargaDatos } from '@shared/models/cierreTurno/CargaDatos';
import { CierreTurno } from '@shared/models/cierreTurno/CierreTurno';
import { MedicionTanque } from '@shared/models/cierreTurno/MedicionTanque';
import { ErrorModel } from '@shared/models/ErrorModel';
import { Abastecedora } from '@shared/models/stock/Abastecedora';
import { Tanque } from '@shared/models/stock/Tanque';
import { MessageService } from '@shell/message.service';
import { StockService } from '@stock/stock.service';
import { TanqueService } from '@stock/tanques.service';
import { Producto } from '@shared/models/despacho/Producto';
import { SharedService } from '@shared/shared.service';
import { formatDate } from '@angular/common';
import { CalculosService } from '@shared/calculos.service';
import { MedicionesService } from '@stock/mediciones.service';
import { ModalConfirmComponent } from '@shared/generic-modals/modal-confirm.component';
import { CierreDiarioService } from '../services/cierre-diario.service';
import { EtapasCierre } from '@shared/enums/EtapasCierreTurno';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-carga-datos-cierre-turno',
  templateUrl: './carga-datos-cierre-turno.component.html',
  styleUrls: ['./carga-datos-cierre-turno.component.css']
})
export class CargaDatosCierreTurnoComponent implements OnInit, OnDestroy {

  cierreRealizoContinuado: CierreTurno;
  aeroplantaCodigo: string;
  tanques: Tanque[];
  indexTanqueParaActualizar = null;
  medicionesParaTanque: boolean = false;
  medicionesModificadas: MedicionTanque[] = [];
  tablaTanques: UntypedFormGroup
  tablaAeroespecialidades: UntypedFormGroup;
  guardando: boolean = false;
  cargandoProductos: boolean = false;
  productos: Producto[] = [];
  productoSeleccionado: Producto;
  loading: boolean = false;
  obteniendoTanques: boolean;
  tanquesGraduaciones: Tanque[];
  message: string = 'C A R G A N D O . . .';
  
  subscription$: Subscription;

  constructor(private fb: UntypedFormBuilder, private stockService: StockService, private spinner: NgxSpinnerService,
    private usuarioService: UsuarioService, private tanquesService: TanqueService, private sharedService: SharedService,
    private router: Router, private cierreService: CierreDiarioService, private activeModel: NgbModal,
    @Inject(LOCALE_ID) public locale: string, private messageService: MessageService,
    private productosService: ProductoService, private calculoService: CalculosService, private medicionesService: MedicionesService, private modal: NgbModal) {
    
  }

  subscripcionConversion15;

  // hooks

  ngOnInit() {
    this.subscription$ = this.cierreService.cierre$.subscribe(cierre => {
      this.cierreRealizoContinuado = cierre ? JSON.parse(JSON.stringify(cierre)) : null;
      if (cierre?.aeroespecialidades !== null) this.startPage();
    });
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }

  startPage() {
    this.tablaTanques = this.fb.group({
    });
    this.tablaAeroespecialidades = this.fb.group({
    })
    this.obteniendoTanques = true;
    this.aeroplantaCodigo = this.usuarioService.getAeroplantaActual().codigoAeroplanta;
    this.cierreRealizoContinuado.aeroespecialidades.sort((a , b) => a.codigoAeroespecialidad.toLocaleUpperCase() > b.codigoAeroespecialidad.toLocaleUpperCase() ? 1 : -1);
    this.cierreRealizoContinuado.medicionesTanques.forEach((value, index) => {
      this.cierreRealizoContinuado.medicionesTanques[index].densidadString = (this.cierreRealizoContinuado.medicionesTanques[index].densidad).toString();
    });
    this.cierreRealizoContinuado.medicionesTanques.sort((a , b) => a.nombreTanque.toLocaleUpperCase() > b.nombreTanque.toLocaleUpperCase() ? 1 : -1);
    this.getTanquesYProductos();
    if(!this.cierreRealizoContinuado.medicionesFueronCargadas && this.cierreRealizoContinuado.aeroplanta.obtieneTelemediciones) this.actualizarTanquesCintelink();
  }


  getTanquesYProductos() {
    this.handleSpinner(true);
    this.cargandoProductos = true;
    forkJoin({   
      tanques: this.tanquesService.getTanquesPorAeroplanta(this.aeroplantaCodigo),  
      productos: this.productosService.obtenerProductos()})
        .subscribe(result => {   
            this.productos = result.productos;
            this.tanques = result.tanques.filter(tanque =>
              this.cierreRealizoContinuado.medicionesTanques.some(medicion => medicion.codigoTanque === tanque.codigo)
            );
            this.cargandoProductos = false;
            this.handleSpinner(false);
            this.verificarGraduacionesTanques();
          });
  }

  actualizarTanqueCintelink(codigoTanque, index) {
    this.indexTanqueParaActualizar = index;
    this.medicionesService.getMedicion(codigoTanque).subscribe(tanque => {
      if (tanque){
        this.cierreRealizoContinuado.medicionesTanques[index].esMedicionCintelink = true;
        this.cierreRealizoContinuado.medicionesTanques[index].fechaHoraMedicion = tanque.fechaHoraMedicion;
        this.changeValueCintelink(index, 'varillado', tanque.varillado);
        this.changeValueCintelink(index, 'nivelNatural', tanque.nivelNatural);
        this.changeValueCintelink(index, 'temperatura', tanque.temperatura);
        this.changeValueCintelink(index, 'nivelAgua', tanque.nivelAgua);
        if (!this.cierreRealizoContinuado.medicionesFueronCargadas) {
          this.changeValueCintelink(index, 'densidadString', 0);
          this.changeValueCintelink(index, 'densidad', 0);
        }        
        this.changeValueCintelink(index, 'nivel', this.calculoService.obtenerCTLNuevo(tanque.temperatura, this.cierreRealizoContinuado.medicionesTanques[index].densidad, tanque.nivelNatural));
      }
      this.indexTanqueParaActualizar = null;
    }, (error:ErrorModel) => {
      this.indexTanqueParaActualizar = null;
      this.messageService.showErrorMessage(`${error.message} \n ${error.description}`);
    })
  }

  actualizarTanquesCintelink() {
    this.medicionesService.getMedicionesMasivas(this.usuarioService.getAeroplantaActual().codigoAeroplanta).subscribe(tanques => {
      let counter = 0;
      this.cierreRealizoContinuado.medicionesTanques.forEach(t => {
        const tanqueCintelink = tanques.find(tC => tC.codigoTanque == t.codigoTanque);
        if(tanqueCintelink) {
          if(Date.parse(tanqueCintelink.fechaHoraMedicion) > Date.parse(t.fechaHora)) {
            t.esMedicionCintelink = true;
            t.fechaHoraMedicion = tanqueCintelink.fechaHoraMedicion;
            this.changeValueCintelink(counter, 'varillado', tanqueCintelink.varillado);
            this.changeValueCintelink(counter, 'nivelNatural', tanqueCintelink.nivelNatural);
            this.changeValueCintelink(counter, 'temperatura', tanqueCintelink.temperatura);
            this.changeValueCintelink(counter, 'nivelAgua', tanqueCintelink.nivelAgua);
            this.changeValueCintelink(counter, 'densidadString', 0);
            this.changeValueCintelink(counter, 'densidad', 0);
            this.changeValueCintelink(counter, 'nivel', this.calculoService.obtenerCTLNuevo(tanqueCintelink.temperatura, this.cierreRealizoContinuado.medicionesTanques[counter].densidad, tanqueCintelink.nivelNatural));
          }
          counter++;
        }
      })
    })
  }

  handleSpinner(loading: boolean) {
    this.loading = loading;
    loading ? this.spinner.show('spinnerCargaDatos') : this.spinner.show('spinnerCargaDatos');
    this.cierreService.loading.set(loading);
  }

  verificarGraduacionesTanques() {
    const nuevasMediciones : MedicionTanque[] = [];

    for (let i = 0; i < this.tanques.length; i++) {
      let esNuevaMedicion = true;
      for (const tanqueCierre of this.cierreRealizoContinuado.medicionesTanques) {
        if (this.tanques[i].codigo == tanqueCierre.codigoTanque) {
          esNuevaMedicion = false;
          break;
        }
      }

      if(esNuevaMedicion){
        const m = new MedicionTanque();
        m.codigoTanque = this.tanques[i].codigo;
        m.nombreTanque = this.tanques[i].nombre;
        m.codigoProducto = this.tanques[i].productoActual.codigoProducto;
        m.nombreProducto = this.tanques[i].productoActual.nombreProducto;
        m.varillado = 0;
        m.nivel = 0;
        m.nivelNatural = 0;
        m.temperatura = 0;
        m.densidad = 0;
        m.nivelAgua = 0;
        m.esNuevo = true;
        m.userName = this.usuarioService.getUsernameByName();
        m.roleStatus = false;
        m.fechaHora = formatDate(new Date(), 'y-MM-ddTHH:mm:ss', this.locale);

        nuevasMediciones.push(m);
      }
    }

    if(nuevasMediciones.length > 0){
      this.cierreRealizoContinuado.medicionesTanques = this.cierreRealizoContinuado.medicionesTanques.concat(nuevasMediciones);
    }

    this.cierreRealizoContinuado.medicionesTanques.forEach(m => {
      m.desactivarUI = true;
      m.desactivarTanque = true;
    });

    for (const tanque of this.tanques) {
      if( tanque.tieneGraduacion || tanque.activo){
        // Habilito campos
        for (const tanqueCierre of this.cierreRealizoContinuado.medicionesTanques) {
          if (tanque.codigo == tanqueCierre.codigoTanque) {
            (tanque.tieneGraduacion) ? tanqueCierre.desactivarUI = false : null;
            (tanque.activo) ? tanqueCierre.desactivarTanque = false : null;
            break;
          }
        }
      }
    }
  }

  //form

  recargarPagina() {
    this.ngOnInit();
  }

  changeValue(id: number, property: string, event: any) {
    if (this.cierreRealizoContinuado.medicionesTanques[id][property] != event.target.value) {
      this.cierreRealizoContinuado.medicionesTanques[id][property] = event.target.value;
      this.cierreRealizoContinuado.medicionesTanques[id].esNuevo = true;

      if(property != 'densidad'){
        this.recalcularVolumenes(property, this.cierreRealizoContinuado.medicionesTanques[id]);
        if (this.cierreRealizoContinuado.medicionesTanques[id].esMedicionCintelink) {
          const tanqueModificado = this.medicionesModificadas.find(t => t.codigoTanque == this.cierreRealizoContinuado.medicionesTanques[id].codigoTanque);
          if(!tanqueModificado) this.medicionesModificadas.push(this.cierreRealizoContinuado.medicionesTanques[id]);
          this.cierreRealizoContinuado.medicionesTanques[id].esMedicionCintelink = false;
        }
      }
    }
  }

  changeValueCintelink(id: number, property: string, value) {
    if (this.cierreRealizoContinuado.medicionesTanques[id][property] != value) {
      this.cierreRealizoContinuado.medicionesTanques[id][property] = value;
      this.cierreRealizoContinuado.medicionesTanques[id].esNuevo = true;
    }
    this.medicionesModificadas = this.medicionesModificadas.filter(t => t.codigoTanque !== this.cierreRealizoContinuado.medicionesTanques[id].codigoTanque);
  }

  changeValueAeroespecialidad(id: number, property: string, event: any) {
    event.target.value != '' ?  this.cierreRealizoContinuado.aeroespecialidades[id][property] = parseInt(event.target.value) : this.cierreRealizoContinuado.aeroespecialidades[id][property] = null;   
  }

  recalcularVolumenes(property, t: MedicionTanque) {
    if(this.subscripcionConversion15 != null){ this.subscripcionConversion15.unsubscribe(); }

    if (t != null && t.varillado.toString() != "" && t.densidad.toString() != '' && t.temperatura.toString() != '') {
      this.medicionesParaTanque = true;
      const varillado = t.varillado.toString();

      const dens = t.densidad.toString();
      const temp = t.temperatura.toString();
      if(property == 'varillado'){
        t.roleStatus = true;
        this.subscripcionConversion15 = this.stockService.getConversionLitrosPorVarillado(t.codigoTanque, varillado)
          .subscribe(volumenLts => {
            t.nivelNatural = parseInt(volumenLts);

            if (dens != "" && temp != "") {
              t.nivel = this.calculoService.obtenerCTLNuevo(temp, dens, volumenLts);

            }

            t.roleStatus = false;
          },
            () => {
              t.roleStatus = false;
              this.medicionesParaTanque = false;
            });
      }else{
        setTimeout(() => {
          const dens = t.densidad.toString();
          const temp = t.temperatura.toString();

          if (dens != "" && temp != "") {
            t.nivel = this.calculoService.obtenerCTLNuevo(temp, dens,  t.nivelNatural);
          }
        }, 200);
      }
    }
  }


  recalcularVolumenNaturalAbastecedora(t: Abastecedora) {
    const volumenLts = Number(t.mediciones.varillado);
    const dens = Number(t.mediciones.densidad);
    const temp = Number(t.mediciones.temperatura);

    if (volumenLts != null && dens != null && temp != null) {
      t.mediciones.nivel = this.calculoService.obtenerCTLNuevo(temp, dens, volumenLts);
    }
  }

  formatDensidad(event, i: number) {
    if (event.charCode == 8 || event.charCode == 0) return null;

    if (event.charCode >= 48 && event.charCode <= 57) {
      this.cierreRealizoContinuado.medicionesTanques[i].densidadString = this.sharedService.formatDensidad(event);
    }
    this.recalcularVolumenes('densidad', this.cierreRealizoContinuado.medicionesTanques[i]);
    return false;
  }

  verificarstocknegativo():boolean {
    let stockCorrecto:boolean=true;
    for (let index = 0; index < this.cierreRealizoContinuado.aeroespecialidades.length; index++) {
      const element:number = this.cierreRealizoContinuado.aeroespecialidades[index].stock;
      if (element<0) {
        stockCorrecto=false;
        break;
      }
    }
    return stockCorrecto;
  }


  confirmarDatos() {

    if(this.medicionesModificadas.length > 0) {
      const modalRef = this.modal.open(ModalConfirmComponent, { centered: true, backdrop: 'static' });
      const nombreTanquesModificados = [];
      this.medicionesModificadas.forEach(m => nombreTanquesModificados.push(m.nombreTanque + " "))
      modalRef.componentInstance.mensaje = "Las telemediciones de los tanques " + nombreTanquesModificados + "han sido modificadas ¿Desea continuar?"
      modalRef.componentInstance.titulo = 'Cierre de turno';
      modalRef.result.then(() => {
        this.cargarDatos();
      }, () => {
        this.guardando = false;
        this.handleSpinner(false);
      });

    } else {
      this.cargarDatos();
    }

  }

  cargarDatos() {
    if(this.verificarstocknegativo()) {
      this.handleSpinner(true);
      this.guardando = true;
      let stringMensaje: string = '';
      const carga = new CargaDatos();
      carga.aeroespecialidades = [];
      carga.medicionesTanques = [];
      //Recorrido de mediciones y carga de datos.
      // this.cierreRealizoContinuado.medicionesTanques.forEach((value, index) => {
      for (let i = 0; this.cierreRealizoContinuado.medicionesTanques.length > i; i++) {
        carga.medicionesTanques.push(new MedicionTanque);
        if (this.cierreRealizoContinuado.medicionesTanques[i].varillado >= 0 && this.cierreRealizoContinuado.medicionesTanques[i].nivel >= 0, this.cierreRealizoContinuado.medicionesTanques[i].nivelNatural >= 0, this.cierreRealizoContinuado.medicionesTanques[i].densidad >= 0) {
          if (this.validarDensidad(this.cierreRealizoContinuado.medicionesTanques[i]) && this.validarTemperatura(this.cierreRealizoContinuado.medicionesTanques[i].temperatura.toString())) {
            // this.cierreRealizoContinuado.medicionesTanques[i].fechaHora = this.formatDate(this.tanques[i].fechaProvisoria.year, this.tanques[i].fechaProvisoria.month, this.tanques[i].fechaProvisoria.day, this.tanques[i].horaCarga.hour - 3, this.tanques[i].horaCarga.minute);
            carga.medicionesTanques[i].codigoTanque = this.cierreRealizoContinuado.medicionesTanques[i].codigoTanque;
            carga.medicionesTanques[i].nombreTanque = this.cierreRealizoContinuado.medicionesTanques[i].nombreTanque;
            carga.medicionesTanques[i].nombreProducto = this.cierreRealizoContinuado.medicionesTanques[i].nombreProducto;
            carga.medicionesTanques[i].codigoProducto = this.cierreRealizoContinuado.medicionesTanques[i].codigoProducto;
            carga.medicionesTanques[i].varillado = Number(this.cierreRealizoContinuado.medicionesTanques[i].varillado);
            carga.medicionesTanques[i].nivel = this.cierreRealizoContinuado.medicionesTanques[i].desactivarTanque ? 0 : Number(this.cierreRealizoContinuado.medicionesTanques[i].nivel);
            carga.medicionesTanques[i].nivelNatural = this.cierreRealizoContinuado.medicionesTanques[i].desactivarTanque ? 0 : Number(this.cierreRealizoContinuado.medicionesTanques[i].nivelNatural);
            carga.medicionesTanques[i].temperatura = Number(this.cierreRealizoContinuado.medicionesTanques[i].temperatura);
            carga.medicionesTanques[i].densidad = Number(this.cierreRealizoContinuado.medicionesTanques[i].densidadString);
            carga.medicionesTanques[i].nivelAgua = Number(this.cierreRealizoContinuado.medicionesTanques[i].nivelAgua);
            carga.medicionesTanques[i].userName = this.usuarioService.getUsernameByName();
            carga.medicionesTanques[i].esNuevo = this.cierreRealizoContinuado.medicionesTanques[i].esNuevo;
          } else {
            stringMensaje += 'El tanque ' + this.cierreRealizoContinuado.medicionesTanques[i].codigoTanque + ' tiene errores en su carga.';
          }
        } else {
          stringMensaje += 'El tanque ' + this.cierreRealizoContinuado.medicionesTanques[i].codigoTanque + ' no tiene cargado datos.';
        }
      }
      let x=0;
      this.cierreRealizoContinuado.aeroespecialidades.forEach((value2, index2) => {
        if (this.cierreRealizoContinuado.aeroespecialidades[index2].stock != null) {
          carga.aeroespecialidades.push(new Aeroespecialidad)
          carga.aeroespecialidades[x].stock = this.cierreRealizoContinuado.aeroespecialidades[index2].stock;
          carga.aeroespecialidades[x].nombreAeroespecialidad = this.cierreRealizoContinuado.aeroespecialidades[index2].nombreAeroespecialidad;
          carga.aeroespecialidades[x].codigoAeroespecialidad = this.cierreRealizoContinuado.aeroespecialidades[index2].codigoAeroespecialidad;
          x++;
        } else {
          stringMensaje += 'La aeroespecialidad ' + this.cierreRealizoContinuado.aeroespecialidades[index2].nombreAeroespecialidad + ' no tiene cargado datos.';
        }
      });
      if (stringMensaje == '') {
        this.cierreService.postCierreCargarDatos(this.aeroplantaCodigo, carga, this.cierreRealizoContinuado)
          .subscribe(result => {
            if (result != null) {
              this.guardando = false;
              this.handleSpinner(false);
              this.cierreRealizoContinuado.comparativas = result.comparativas;
              this.cierreRealizoContinuado.comparativasExpendedoras = result.comparativasExpendedoras;
              this.cierreRealizoContinuado.totalesProductos = result.totalesProductos;
              this.cierreRealizoContinuado.etapaActual = EtapasCierre.Comparativas;
              this.completeStep(EtapasCierre.CargarDatos);
              this.messageService.showSuccessMessage('La carga de datos se envió correctamente.');
            }

          }, (err: ErrorModel) => {
            this.guardando = false;
            this.handleSpinner(false);
            this.messageService.showErrorMessage('Hubo un error al enviar la información' + err.description);
          });
      } else {
        this.guardando = false;
        this.handleSpinner(false);
        this.messageService.showErrorMessage('Por favor complete correctamente los datos.' + stringMensaje)
      }
    }else{
      this.messageService.showErrorMessage("La cantidad del conteo de aeroespecialidad debe ser mayor/igual a cero");
    }
  }

  completeStep(index: EtapasCierre): void {
    this.cierreService.updateStepProgress(index, this.cierreRealizoContinuado);
  }

  // validaciones

  validarDensidad(medicion: MedicionTanque) {
    if (medicion.densidad != null) {
      this.productoSeleccionado = this.productos.find(element => element.codigoProducto === medicion.codigoProducto);
      let esValido = true;
      esValido = (medicion.densidad >= this.productoSeleccionado?.densidadMin && medicion.densidad <= this.productoSeleccionado?.densidadMax);
      return esValido;
    }
  }

  validarTemperatura(temp: string): boolean {
    let valida = true;
    if (parseFloat(temp) > 100) {
      valida = false;
    }

    if (parseFloat(temp) < -50) {
      valida = false;
    }
    return valida;
  }
}
